import { render, staticRenderFns } from "./Consumers.vue?vue&type=template&id=45a97df9"
import script from "./Consumers.vue?vue&type=script&lang=js"
export * from "./Consumers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports